import React from 'react';
import { prop } from 'ramda';
import { useUserSelector } from 'js/store/hooks';
import { componentService } from 'js/services/component.service';

export const LoggedOut = ({ children }) => {
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));

    if (isLoggedIn) {
        return null;
    }

    return <>{children}</>;
};

componentService.registerWebContentComponents({ LoggedOut });
